import React, { useEffect } from "react";
import HeaderSky from "../../views/dashboard/header/header";
import { ErrorCard } from "../errorCard";
import { NoAccessCard } from "../NoAccessCard";
import { SuspendedAccountCard } from "../SuspendedAccountCard";
import { InactiveAccountCard } from "../InactiveAccountCard";
import SetupPage from "../accountSetupPage/setupPage";
import { signalAppReady } from "../../utils/appLoadingSignal";

interface AppLoadingStatesProps {
  userAccesstoInstance: boolean;
  accessDeniedReason?: string | null;
  showExternalTenantCreationError: boolean;
  isCheckResourceFailed: boolean;
  isShowCreateTenant: boolean;
  createOwnInfrastructure: boolean;
  isSetupFinished: boolean;
  hideExternalTenantCreationError: () => void;
  createResourceForTenant: () => void;
  createOwnInfrastructureFn: () => void;
}

export function AppLoadingStates({
  userAccesstoInstance,
  accessDeniedReason,
  showExternalTenantCreationError,
  isCheckResourceFailed,
  isSetupFinished,
  hideExternalTenantCreationError,
}: AppLoadingStatesProps) {
  // Signal startup overlay to dismiss when showing interactive UI (not a loader)
  useEffect(() => {
    if (!userAccesstoInstance || showExternalTenantCreationError || !isCheckResourceFailed) {
      signalAppReady();
    }
  }, [userAccesstoInstance, showExternalTenantCreationError, isCheckResourceFailed]);

  if (!userAccesstoInstance) {
    return (
      <div style={{ height: "100vh" }}>
        <HeaderSky />
        {accessDeniedReason === "suspended" ? (
          <SuspendedAccountCard />
        ) : accessDeniedReason === "inactive" ? (
          <InactiveAccountCard />
        ) : (
          <NoAccessCard />
        )}
      </div>
    );
  }

  if (showExternalTenantCreationError) {
    return (
      <ErrorCard
        errorDescription={
          <>
            An error occurred while setting up the infrastructure. Please try again. If the problem
            persists,{" "}
            <a
              href="https://skypointcloud.com/customer-support/"
              target="_blank"
              style={{ fontWeight: "600" }}
              rel="noreferrer"
            >
              Contact support
            </a>
          </>
        }
        showRefreshButton={true}
        refreshButtonText="Try again"
        callBackFunctionOnRefresh={hideExternalTenantCreationError}
      />
    );
  }

  if (isCheckResourceFailed) {
    return null;
  }

  return <SetupPage isSetupFinished={isSetupFinished} />;
}
